import Head from 'next/head';
import { useRouter } from 'next/router';
import React from 'react';

import { useBooking, useRedirectToCorrectStep } from '@/booking';
import { createAmendBookingCheckoutNavigator } from '@/booking-amendment';
import { AmendBookingRequest } from '@/booking-management';
import { getAmendBookingPageInitialProps } from '@/booking-management/routing';
import { BookingConfirmationContainer } from '@/booking/container/BookingConfirmationContainer.component';
import { usePageTitle } from '@/brand';
import { Page } from '@/core/components';
import Footer from '@/hox-core/components/Footer.component';
import { useTranslation } from '@/i18n';
import { Header, HeaderNav } from '@/ui/layout';
import { Spacer } from '@/ui/spacing';

interface AmendmentConfirmationPageProps extends AmendBookingRequest {}

export const AmendmentConfirmationPage: React.FC<
  AmendmentConfirmationPageProps
> = (props) => {
  const { t } = useTranslation('confirmation');

  const pageTitle = usePageTitle(t('pageTitle'));
  const router = useRouter();
  const oldBooking = useBooking(props.oldBooking);
  const navigator = createAmendBookingCheckoutNavigator({
    request: props,
    router,
    operaId: oldBooking?.pmsId,
  });

  useRedirectToCorrectStep({
    ...props.newBooking,
    currentStep: 'confirmation',
    navigator,
  });

  return (
    <React.Fragment>
      <Head>
        <title>{pageTitle}</title>
      </Head>
      <Page>
        <Header>
          <HeaderNav />
        </Header>
        <BookingConfirmationContainer
          bookingRequest={props.newBooking}
          oldBooking={props.oldBooking}
        />
        <Spacer s="xl" />
        <Footer />
      </Page>
    </React.Fragment>
  );
};

(AmendmentConfirmationPage as any).getInitialProps =
  getAmendBookingPageInitialProps;

export default AmendmentConfirmationPage;
